// extracted by mini-css-extract-plugin
export default {"persons-wrapper":"persons-wrapper--pl6kz","personsWrapper":"persons-wrapper--pl6kz","persons":"persons--Nbibe","person":"person--r_ZrB","blink":"blink--VEnkN"};